// Tools合集页面导航配置 badge 支持 热门、新、推荐
export const toolsConfig = [
  {
    id: 1,
    title: '内部工具',
    description: '当前站点内部路由工具————原导航列表',
    icon: 'Monitor',
    type: 'group',
    children: [
      {
        id: 11,
        title: '模板报表',
        description: '自定义模板报表生成工具',
        icon: 'Document',
        type: 'internal',
        route: '/template-report',
        badge: '热门'
      },

      {
        id: 12,
        title: '周期任务',
        description: '多种周期任务配置',
        icon: 'Setting',
        type: 'internal',
        route: '/cycle-task-job',
        badge: '热门'
      },
      {
        id: 13,
        title: '转发Api',
        description: '为三方接口配置Api转发调用服务',
        icon: 'Platform',
        type: 'internal',
        route: '/dw-api',
        badge: '新'
      },
      {
        id: 14,
        title: '渠道流量',
        description: '提供Dataworks渠道流量数据导出',
        icon: 'TrendCharts',
        type: 'internal',
        route: '/channel-flow',
        badge: '推荐'
      },
      {
        id: 15,
        title: '淘宝短链',
        description: '淘宝短链批量转换工具',
        icon: 'Link',
        type: 'internal',
        route: '/tools-tb',
        badge: '新'
      },
      {
        id: 16,
        title: '文件互传',
        description: 'P2P局域网文件互传工具',
        icon: 'Connection',
        type: 'internal',
        route: '/file-chat',
        badge: '新'
      },
      {
        id: 17,
        title: '双重安全验证',
        description: '双重安全验证跳过工具',
        icon: 'Unlock',
        type: 'internal',
        route: '/tools-double-verification',
        badge: '新'
      },
            {
        id: 18,
        title: '埋点原始数据查询',
        description: '埋点原始数据查询工具',
        icon: 'Unlock',
        type: 'internal',
        route: '/tracking-data-query',
        badge: '新'
      },
      {
        id: 19,
        title: '授权指南',
        description: '京东/淘宝授权配置指南和链接生成工具',
        icon: 'Setting',
        type: 'internal',
        route: '/authorization-guide',
        badge: '新'
      },
    ]
  },
  {
    id: 2,
    title: '外部工具',
    description: 'By Cola提供的外部工具',
    icon: 'Setting',
    type: 'group',
    children: [
      {
        id: 21,
        title: 'Jar编辑',
        description: '为jar包修改配置文件的工具',
        icon: 'Tools',
        type: 'external',
        url: 'https://jar.nxqlhhk.top/',
        target: '_blank',
        badge: '新'
      },
      {
        id: 22,
        title: '数据格式化工具',
        description: '常用数据格式化工具，支持Json、DataWorks数据、Sql等',
        icon: 'Edit',
        type: 'external',
        url: 'https://tools.nxqlhhk.top/',
        target: '_blank',
        badge: '新'
      },
      {
        id: 23,
        title: '产品化数据商品比对',
        description: '产品化数据商品比对工具',
        icon: 'Brush',
        type: 'external',
        url: 'https://item.nxqlhhk.top/',
        target: '_blank',
        badge: '新'
      },
    ]
  },
  {
    id: 3,
    title: '外链工具',
    description: '常用第三方工具链接',
    icon: 'Link',
    type: 'group',
    children: [
      {
        id: 31,
        title: 'Json在线解析',
        description: 'Json在线解析工具',
        icon: 'Link',
        type: 'external',
        url: 'https://www.json.cn/',
        target: '_blank',
        badge: '新'
      },
    ]
  },
  {
    id: 4,
    title: '订单清洗',
    description: '订单清洗相关工具',
    icon: 'Link',
    type: 'group',
    children: [
      {
        id: 41,
        title: '淘宝订单清洗',
        description: '淘宝订单清洗工具',
        icon: 'Link',
        type: 'internal',
        route: '/tb-order-clean',
        badge: '新'
      },
      {
        id: 42,
        title: 'JD订单清洗',
        description: 'JD订单清洗工具',
        icon: 'Link',
        type: 'external',
        url: 'https://t-jdlbx.nike.com.cn/order-push/web/',
        target: '_blank',
        badge: '新'
      },
    ]
  }
]
